import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, OnChanges, inject } from '@angular/core';
import { TranslationService } from '../../service/translation.service';
import { ToastService } from '../../service/toast.service';
import { AppConstants } from '../../constants/constants';
import { take } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SafePipe } from '../../pipes/safe.pipe';

@Component({
  selector: 'app-common-media-upload',
  templateUrl: './common-media-upload.component.html',
  styleUrls: ['./common-media-upload.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, SafePipe]
})
export class CommonMediaUploadComponent implements OnChanges {

  private readonly translationService = inject(TranslationService)
  private readonly toastService = inject(ToastService)

  public translationData: any;
  public mediaFiles: string[] = [];
  public mediaFilesOverlay: string[] = [];
  public showOverlayFlag: boolean = false;
  public isMediaDisable: boolean = true;
  public selectedLocation: any = null;
  public markFieldsAsRequired: boolean = false;
  public commonLables = AppConstants.COMMON_LABELS;

  // All Input and Output declarations go here
  @Input() currentStep: string = "";
  @Input() tourCoverImg: string = "";
  @Input() markMediaFieldsAsRequired: boolean = false;
  @Input() saveImgWithCopyright: boolean = false;

  @Output() mediaData = new EventEmitter<any>();
  @Output() mediaFilesUpdated = new EventEmitter<number>();

  @ViewChild('myFileInput', { static: false }) myFileInput: any;


  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.saveImgWithCopyright?.currentValue) {
      this.displayMediaThumbnailsOnConfirm();
    }
  }

  /**
   * @description Called when media is uploaded, checks validation and displays image
   * @param event 
   * @returns void
   */
  public uploadMediaOnClk(_event: any): void {
    // Track upload disabled - locations module removed
  }

  public showMediaGallery(): void {
    // Media gallery disabled - locations module removed
  }

  /**
   * @description Called when user has confirmed all his images from copy right dialog
   */
  public displayMediaThumbnailsOnConfirm(): void {
    this.mediaFiles = this.mediaFilesOverlay = [];
  }

  /**
   * @description If only 3 images are there show the 3 images as 3 boxes. If number of images exceed 3, 
   * Show 3 boxes with first 2 images and 3rd box will have an image with overlay and number of files remaining
   * @param selectedMedia 
   */
  public showMediaWithoutOverlay(selectedMedia: { media: string, copyrightData: any[] }[]): void {
    this.mediaFiles = selectedMedia.slice(0, 3).map((media) => media.media);
    if (this.mediaFiles.length >= 3) {
      this.showMediaThumbnailsWithOverlay(selectedMedia, 3);
    }
  }

  /**
   * @description To push images into the 3rd box and cover it with an overlay.
   * Additionally display the number of images
   * @param selectedMedia 
   * @param startingIndex starts with 3 always b'cause 3rd box has the overlay
   */
  public showMediaThumbnailsWithOverlay(selectedMedia: { media: string, copyrightData: any }[], startingIndex: number): void {
    this.mediaFilesOverlay = selectedMedia.slice(startingIndex).map((media) => media.media);
    if (this.mediaFilesOverlay.length > 0) {
      this.showOverlayFlag = true;
    }
  }

  /**
   * @description Loads images while editing a AMG annotation
   */
  public loadAnnotationImageThumnails(): void {
    // Disabled - locations module removed
  }

  /**
   * @description shows images in the left panel for cover image
   */
  public loadCoverImageThumbnails(): void {
    // Disabled - locations module removed
  }

  /**
   * @description Called to populate the media files for the copyright dialog
   * This is called for both cover image and annotation images. Called when the
   * panel changes based on current step
   * @param mediaFiles 
   */
  public populateMediaForGallery(_mediaFiles: any[]): void {
    // Disabled - locations module removed
  }

  public showToastErrorMsg(type: any, message: string): void {
    this.toastService.show(type, message, "8%", "40%");
    setTimeout(() => {
      this.toastService.hide();
    }, AppConstants.MIN_TIME_TOASTER);
  }

  public checkIsInTrackUpdateState(): boolean {
    return false;
  }

}
